import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResults220326 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 22/03/2026 Results(Bangkok)</h3>
      <br />
      <br />

        <div><Link to='/conduct-amornpont'>1. AAT 2188  MR.AMORNPON TEEPANART(PASS with Distinction)---Accquired Rank 3DAN</Link></div>
        <br />
        <div><Link to='/conduct-nitchakarnt'>2. AAT 7759  CPO1.NITCHAKARN THAWORNKAN(PASS with Distinction)---Accquired Rank SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-chaiyutv'>3. AAT  8017  MAJ.GEN. CHAIYUT VAJIRAVARABHAKTI(PASS with Distinction)---Accquired Rank SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-suteed'>4. AAT  8023  COL.SUTEE DUANGTOON(PASS with Distinction)---Accquired Rank SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-niwats'>5. ATT  6670  MR.NIWAT SEESANGNGAM(PASS with Distinction)---Accquired Rank 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-niratb'>6. AAT 6571  MR.NIRAT BOONYASAWET(PASS)---Accquired Rank 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>7. ATT  7951  MS.NAPASANUN VONGVIVAT(PASS)---Accquired Rank 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>8. ATT  7952  MR.ISSARIYAPA ROOPSUWANNAKUL(PASS)---Accquired Rank 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>9. AAT  8007  MR.KARNT SRISUWAN(PASS)---Accquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>10. AAT  8008  MR.PAKAWAD NANTAJURAPLO(PASS)---Accquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-archirawishp'>11. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(PASS)---Accquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>12. AAT  8021  MS.VU NGUYEN QUYNH TRAM(PASS)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-nutchan'>13. ATT  7955  MS.NUTCHA  NAKAEW(PASS with Distinction)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-matsakaj'>14. ATT  8002  MR.MATSAKA JANSAWANG(PASS with Distinction)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-patawank'>15. ATT  8050  MS.PATAWAN KANPLIEN(PASS)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-chakchaia'>16. AAT  8022  1st LT.CHAKCHAI ANUPONGPAT(PASS)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-kosinm'>17. AAT 8051  MR.KOSIN MUNGCHAROEN(PASS)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-praphatpongy'>18. AAT  8038  MR.PRAPHATPONG YOODEE(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-naras'>19. AAT  8040  MR.NARA SINGHSATHITSUK(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-narat'>20. AAT  8033  MS.NARA TAKIGUCHI(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-cheiax'>21. AAT  8034  MR.CHAY XAVIER(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pawatchakornh'>22. AAT 8052  MR.PAWATCHAKORN HASUNHA(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-jasona'>23. AAT 8053  MR.ANG HUAN YIK(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResults220326;
